module.exports = __webpack_public_path__ + "img/logo_extracadabra_full.ce52283a.svg";